import React from 'react';
import { useSelector } from 'react-redux';
import { USD_TO_CAD_CONVERSION_RATE } from 'constants/currency';
import {
  Container,
  ShippingVender,
  ShippingCost,
  Heading,
  Heading1,
  Table,
  P,
} from 'styles/components/ShippingDetails';

const ShippingCostBody = ({ cost, selectedVendor }) => {
  const currency = useSelector((state) => state?.currency?.value);

  const primaryCost =
    currency === 'USD'
      ? cost.PrimaryCost.toFixed(2)
      : (Number(cost.PrimaryCost) * USD_TO_CAD_CONVERSION_RATE).toFixed(2);

  const secondaryCost =
    currency === 'USD'
      ? cost.SecondaryCost.toFixed(2)
      : (Number(cost.SecondaryCost) * USD_TO_CAD_CONVERSION_RATE).toFixed(2);

  return (
    <Container>
      <ShippingVender>Price Chart - {selectedVendor.Title}</ShippingVender>
      <ShippingCost>
        <Heading>
          {cost?.ShippingTimeMinInDays} - {cost?.ShippingTimeMaxInDays} Business
          Days
        </Heading>
        <Table>
          <P>Size</P>
          <P>XS</P>
          <P>S</P>
          <P>M</P>
          <P>L</P>
          <P>XL</P>
          <P>2XL</P>
        </Table>
        <Heading1>FIRST ITEM</Heading1>
        <Table>
          <P>Shipping Cost ({currency})</P>
          <P>${primaryCost} </P>
          <P>${primaryCost} </P>
          <P>${primaryCost} </P>
          <P>${primaryCost} </P>
          <P>${primaryCost} </P>
          <P>${primaryCost} </P>
        </Table>

        <Heading1>ADDITIONAL ITEMS</Heading1>
        <Table>
          <P>Shipping Cost ({currency})</P>
          <P>${secondaryCost} </P>
          <P>${secondaryCost} </P>
          <P>${secondaryCost} </P>
          <P>${secondaryCost} </P>
          <P>${secondaryCost} </P>
          <P>${secondaryCost} </P>
        </Table>
      </ShippingCost>
    </Container>
  );
};

export default ShippingCostBody;
